import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React from 'react';
import Home from './Pages/Home';
import Contact from './Pages/Contact';
import Overons from './Pages/Overons';
import Aanbod from './Pages/Aanbod';
import AdminPage from './Pages/AdminPage';
import Login from './Pages/Login'; 
import NavBar from './Comp/NavBar'; 
import ProductPage from './Pages/ProductPage';
import FAQ from './Pages/FAQ';

//Flipped a brick into an empire DONT fuck with me.
const App = () => {
    return (
        <Router>
            <div className="min-h-screen">
                <NavBar />
                <div className="pt-[100px]">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/Admin" element={<AdminPage />} />
                        <Route path="/Aanbod" element={<Aanbod />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/overons" element={<Overons />} />
                        <Route path="/Login" element={<Login />} />
                        <Route path="/Veelgesteldevragen" element={<FAQ />} />
                        <Route path="/product/:id" element={<ProductPage />} /> 
                        <Route path="*" element={<Home />} /> 
                    </Routes>
                </div>
            </div>
        </Router>
    );
};

export default App;